import { render, staticRenderFns } from "./NoticeDetail.vue?vue&type=template&id=3ad8c543&"
import script from "./NoticeDetail.vue?vue&type=script&lang=ts&"
export * from "./NoticeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VTextarea})
